var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCoolDownOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 92,
    viewBox: "0 0 64 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 91.4545L0.181641 59.6363L6.54528 53.159L27.4544 74.0682V41.4545H36.5453V74.0682L57.4544 53.2727L63.818 59.6363L31.9998 91.4545ZM27.4544 32.3636V18.7272H36.5453V32.3636H27.4544ZM27.4544 9.63632V0.54541H36.5453V9.63632H27.4544Z",
    fill: "#F57423"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCoolDownOrange);
export default __webpack_public_path__ + "static/media/arrow_cool_down_orange.8962ef6e15164ebf2a26f448dbde4def.svg";
export { ForwardRef as ReactComponent };